// ----------------------------------------------------------------------

export default function TableSortLabel(theme) {
    return {
        MuiTableSortLabel: {
            styleOverrides: {
                root: {
                    fontWeight: theme.typography.fontWeightRegular,
                    '&.Mui-active': {
                        color: theme.palette.text.primary,
                        fontWeight: theme.typography.fontWeightBold,
                    },
                    '&.Mui-active .MuiTableSortLabel-icon': {
                        color: theme.palette.text.primary,
                        fontWeight: theme.typography.fontWeightBold,
                    },
                },
            },
        },
    };
}
